
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Contrôle d\'accès Belgique',
      description: 'Solutions de contrôle d\'accès professionnelles pour sécuriser vos locaux en Belgique. Installation à Charleroi, Bruxelles, Namur, Liège, Mons.',
      features: ['Badges et cartes d\'accès', 'Codes PIN personnalisés', 'Reconnaissance biométrique', 'Gestion centralisée'],
      image: 'https://public.readdy.ai/ai/img_res/687f24cd5a05ef5a598f8c4ec6fb8f85.jpg',
      color: 'text-blue-500',
      alt: 'Contrôle d\'accès Belgique - Installation système sécurité'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Alarme maison Belgique',
      description: 'Installation d\'alarme maison en Belgique. Systèmes d\'alarme connectés et performants pour une surveillance 24/7 de votre domicile.',
      features: ['Détection de mouvement', 'Sirènes et alertes', 'Surveillance 24h/24', 'Application mobile'],
      image: 'https://readdy.ai/api/search-image?query=RISCO%20Lightsys%20%20alarm%20system%20control%20panel%2C%20professional%20security%20alarm%20device%20with%20LED%20display%20and%20keypad%2C%20modern%20white%20alarm%20control%20panel%20mounted%20on%20wall%2C%20sophisticated%20security%20system%20interface%2C%20professional%20installation&width=500&height=400&seq=risco-lightsys&orientation=landscape',
      color: 'text-red-500',
      alt: 'Alarme maison Belgique - Système alarme sécurité'
    },
    {
      icon: 'ri-eye-line',
      title: 'Caméra de surveillance Belgique',
      description: 'Installation caméra de surveillance en Belgique. Systèmes de vidéosurveillance professionnels pour prévenir toute intrusion.',
      features: ['Caméras haute définition', 'Vision nocturne', 'Surveillance périmétrique', 'Enregistrement vidéo'],
      image: 'https://readdy.ai/api/search-image?query=Hikvision%20security%20camera%20professional%20surveillance%20system%2C%20white%20dome%20security%20camera%20mounted%20on%20ceiling%2C%20modern%20CCTV%20camera%20with%20infrared%20night%20vision%2C%20high-tech%20video%20surveillance%20equipment%2C%20professional%20security%20monitoring%20solution&width=500&height=400&seq=hikvision-camera&orientation=landscape',
      color: 'text-green-500',
      alt: 'Caméra de surveillance Belgique - Vidéosurveillance professionnelle'
    },
    {
      icon: 'ri-fire-line',
      title: 'Détecteur incendie Belgique',
      description: 'Installation détecteur incendie en Belgique. Systèmes de prévention incendie professionnels pour la protection de vos locaux.',
      features: ['Détecteurs de fumée', 'Alarmes incendie', 'Systèmes d\'extinction', 'Maintenance préventive'],
      image: 'https://readdy.ai/api/search-image?query=Aritech%20fire%20detector%20professional%20fire%20safety%20equipment%2C%20white%20smoke%20detector%20mounted%20on%20ceiling%2C%20modern%20fire%20detection%20system%2C%20professional%20fire%20alarm%20device%2C%20fire%20safety%20equipment%20installation%2C%20clean%20white%20background&width=500&height=400&seq=aritech-fire&orientation=landscape',
      color: 'text-orange-500',
      alt: 'Détecteur incendie Belgique - Sécurité incendie professionnelle'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Services Sécurité Électronique Belgique
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            <strong>Entreprise sécurité Belgique</strong> spécialisée dans l'installation d'<strong>alarme maison</strong>, <strong>caméra de surveillance</strong>, <strong>contrôle d'accès</strong> et <strong>détecteur incendie</strong>
          </p>
          <div className="mt-4 text-lg text-gray-500">
            Service Charleroi • Bruxelles • Namur • Liège • Mons • Toute la Belgique
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/30"></div>
                <div className={`absolute top-6 left-6 w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-lg`}>
                  <i className={`${service.icon} text-3xl ${service.color}`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <i className={`ri-check-line ${service.color} mr-3 text-lg`}></i>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Section villes desservies */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-blue-500 rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Zones d'intervention en Belgique</h3>
          <div className="grid md:grid-cols-5 gap-4 text-lg">
            <div className="flex items-center justify-center">
              <i className="ri-map-pin-line mr-2"></i>
              <strong>Charleroi</strong>
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-map-pin-line mr-2"></i>
              Bruxelles
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-map-pin-line mr-2"></i>
              Namur
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-map-pin-line mr-2"></i>
              Liège
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-map-pin-line mr-2"></i>
              Mons
            </div>
          </div>
          <p className="mt-4 text-lg opacity-90">
            Et dans toute la Belgique pour vos projets de sécurité électronique
          </p>
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            <i className="ri-phone-line mr-2"></i>
            Devis gratuit sécurité Belgique
          </button>
        </div>
      </div>
    </section>
  );
}